import React from "react";
import PropTypes from "prop-types";
import {
  FormControlLabel,
  Grid,
  FormControl,
  Radio,
  RadioGroup,
  Typography,
  Box,
} from "@mui/material";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import fordStyles from "../fieldView/FieldReporting-Ford.module.scss";
import lincolnStyles from "../fieldView/FieldReporting-Lincoln.module.scss";
import EMPSelectField from "../../shared/components/EMPSelectField/EMPSelectField";
import EMPDatePicker from "../../shared/components/EMPDatePicker/EMPDatePicker";

const ReportFilter = (props) => {
  const isFordBrand = IS_FORD_BRAND(props.brand);
  const styles = isFordBrand ? fordStyles : lincolnStyles;
  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <Typography variant="body1">
            {props.t("fieldReporting.dateRange")}
          </Typography>
          <Typography variant="subtitle2">
            {props.t("fieldReporting.dateRangeSub")}
          </Typography>
        </Grid>
      </Grid>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <RadioGroup
            value={props.dateRangeMethod}
            onChange={props.toggleRadio}
          >
            <Box sx={{ mt: 4, mb: 6 }}>
              <FormControlLabel
                value="auto"
                control={<Radio />}
                data-testid="auto"
                checked={props.dateRangeMethod === "auto"}
                label={
                  <Grid container alignItems="center" spacing={4}>
                    <Grid item>
                      <FilterDropdown
                        id="dateRange"
                        onDropdownChange={props.handleDateRangeChange}
                        items={props.dateRanges}
                        selectedValue={props.dateRange}
                        disabled={false}
                        t={props.t}
                        styles={styles}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        {props.t("fieldReporting.or")}
                      </Typography>
                    </Grid>
                  </Grid>
                }
              />
            </Box>
            <Box>
              <FormControlLabel
                value="manual"
                control={<Radio />}
                data-testid="manual"
                checked={props.dateRangeMethod === "manual"}
                label={
                  <div className={styles.datePickerWrapper}>
                    <div className={styles.toFromDatePickerWrapper}>
                      <Typography variant="body2">
                        {props.t("fieldReporting.from")}
                      </Typography>
                      <Box sx={{ width: 224 }}>
                        <EMPDatePicker
                          incomingDate={props.fromDate}
                          maxDate={new Date()}
                          transportFormData={props.handleFromDateChange}
                          id="fromDate"
                        />
                      </Box>
                    </div>
                    <div className={styles.dateDivider} />
                    <div className={styles.toFromDatePickerWrapper}>
                      <Typography variant="body2">
                        {props.t("fieldReporting.to")}
                      </Typography>
                      <Box sx={{ width: 224 }}>
                        <EMPDatePicker
                          incomingDate={props.toDate}
                          maxDate={new Date()}
                          transportFormData={props.handleToDateChange}
                          id="toDate"
                          minDate={props.fromDate}
                        />
                      </Box>
                    </div>
                  </div>
                }
              />
            </Box>
          </RadioGroup>
        </Grid>
      </Grid>
    </>
  );
};

const FilterDropdown = (props) => {
  const menuItems = [
    {
      text: props.t("GeneralEMP.Select"),
      value: "Select",
    },
    {
      text: props.t("GeneralEMP.All"),
      value: "All",
    },
  ];
  if (props.items) {
    props.items.forEach((item) => {
      menuItems.push({
        text: item,
        value: item,
      });
    });
  }
  return (
    <FormControl
      id={props.id}
      className={props.styles.modelFormControl}
      disabled={props.disabled}
    >
      <Box sx={{ width: 224 }}>
        <EMPSelectField
          testId={props.id}
          value={props.selectedValue}
          onChange={(e) => props.onDropdownChange(e)}
          menuItems={menuItems}
        />
      </Box>
    </FormControl>
  );
};

const dateValuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.instanceOf(Date),
]);

ReportFilter.propTypes = {
  brand: PropTypes.string.isRequired,
  dateRange: PropTypes.string,
  dateRangeMethod: PropTypes.string.isRequired,
  dateRanges: PropTypes.arrayOf(PropTypes.string),
  fromDate: dateValuePropType,
  handleDateRangeChange: PropTypes.func.isRequired,
  handleFromDateChange: PropTypes.func.isRequired,
  handleToDateChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  toDate: dateValuePropType,
  toggleRadio: PropTypes.func.isRequired,
};

ReportFilter.defaultProps = {
  dateRange: "",
  dateRanges: [],
  fromDate: null,
  toDate: null,
};

FilterDropdown.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string),
  onDropdownChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  styles: PropTypes.shape({
    modelFormControl: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

FilterDropdown.defaultProps = {
  disabled: false,
  items: [],
  selectedValue: "",
};

export default withTranslation("emp")(ReportFilter);
